import TripCheckoutBookOrHold from './trip-checkout-book-or-hold-component';
import TripCheckoutBookOrHoldService from './trip-checkout-book-or-hold-service';

import './trip-checkout-book-or-hold.scss';

const MODULE_NAME = 'app.trip.checkout.book-or-hold';
const module = angular.module(MODULE_NAME, [])
    .directive(TripCheckoutBookOrHold.DIRECTIVE_NAME, TripCheckoutBookOrHold)
    .service('tripCheckoutBookOrHoldService', TripCheckoutBookOrHoldService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-checkout-book-or-hold/trip-checkout-book-or-hold-module.js